import { CheckIcon } from '@cmsgov/ds-medicare-gov'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface IUpdatedStatusProps {
  showText?: boolean
}

export const UpdatedStatus: React.FC<IUpdatedStatusProps> = ({ showText }) => {
  const { t } = useTranslation('common')
  return (
    <div className='ds-u-display--flex ds-u-align-items--center' data-testid='updated-status'>
      <CheckIcon className='ds-c-icon-color--primary my-u-mr--2' />
      {showText && <span>{t('cards.status.updated')}</span>}
    </div>
  )
}
